import { namespacedRouterActions } from '@loan_market/react-router-redux-multi';
import { HISTORY_NAMESPACE } from 'routes/memoryRoutes.js';

export default namespacedRouterActions(HISTORY_NAMESPACE);
